import { GlobalStyles } from '@service-victoria/component-library/utils/globalStyles';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { Routes } from './routes/routes';
import { app as Context } from 'app/context';

const Wrapper = styled.div``;

const App: React.FC = () => {
  // load the previous saved context if there was any
  const { currentState } = Context.useAppContext();
  return (
    <Wrapper>
      <ThemeProvider theme={{ baseURL: import.meta.env.BASE_URL }}>
        <GlobalStyles />
        <Router basename={import.meta.env.BASE_URL}>
          <Context.AppProvider state={currentState} id='App'>
            <Routes />
          </Context.AppProvider>
        </Router>
      </ThemeProvider>
    </Wrapper>
  );
};

export default App;
